import React from "react";
import email from "../assets/email_icon_black.png";
import instagram from "../assets/instagram_icon.png";
import facebook from "../assets/facebook_icon.png";

function Contacto() {
  const handleSubmit = (event) => {
    event.preventDefault();

    const formData = new FormData(event.currentTarget);
    const nombre = formData.get("nombre")?.toString().trim() || "";
    const apellido = formData.get("apellido")?.toString().trim() || "";
    const email = formData.get("email")?.toString().trim() || "";
    const telefono = formData.get("telefono")?.toString().trim() || "";
    const asunto = formData.get("asunto")?.toString().trim() || "Consulta desde la web";
    const pais = formData.get("pais")?.toString().trim() || "";
    const mensaje = formData.get("mensaje")?.toString().trim() || "";

    const body = [
      `Nombre: ${nombre}`,
      `Apellido: ${apellido}`,
      `Email: ${email}`,
      `Telefono: ${telefono}`,
      `Pais: ${pais}`,
      "",
      "Mensaje:",
      mensaje,
    ].join("\n");

    window.location.href = `mailto:info@entrecor.com.ar?subject=${encodeURIComponent(
      asunto
    )}&body=${encodeURIComponent(body)}`;
  };

  return (
    <>
      <div id="contacto" className="bg-white grid grid-cols-1 lg:grid-cols-12 container mx-auto px-5 py-8 sm:p-8 gap-8">
        <div className="lg:col-start-2 lg:col-span-4 lg:border-r lg:border-r-black lg:pr-4" data-scroll-reveal>
          <div className="grid grid-cols-[auto,3fr] gap-4 items-center mb-4">
            <div className="relative flex items-center justify-center w-14 h-14 bg-[#BD9A5F] rounded-2xl shadow-lg">
              <span className="text-white text-3xl font-light font-gotham">
                C
              </span>
            </div>
            <h3 className="text-xl flex items-center font-noto text-[#3A3A3C]">
              Contacto
            </h3>
          </div>
          <div className="pl-0 lg:pl-[4.5rem]">
            <h1 className="text-2xl sm:text-3xl font-bold text-[#3A3A3C] mb-4">
              Comunicate con nosotros
            </h1>
            <p className="text-[#3A3A3C] text-md">
              Si necesitás más información sobre nuestros servicios no dudes en
              ponerte en contacto a través de nuestro formulario.
            </p>
          </div>
          <div className="pl-0 lg:pl-[4.5rem] mt-16">
            <div className="flex flex-col gap-5">
              <div className="flex flex-row items-center">
                <img src={email} alt="email" className="w-10" />
                <a href="mailto:info@entrecor.com.ar" className="text-[#3A3A3C] text-md ml-4 hover:underline">
                  info@entrecor.com.ar
                </a>
              </div>
              <div className="flex flex-row gap-4">
                <a
                  href="https://www.facebook.com/profile.php?id=61558971364968"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={facebook} alt="facebook" className="w-14" />
                </a>
                <a
                  href="https://www.instagram.com/entrecor.sa/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={instagram} alt="instagram" className="w-14" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="lg:col-start-6 lg:col-span-7 px-0 lg:px-8" data-scroll-reveal data-scroll-reveal-delay="120ms">
          <form className="contact-form grid grid-cols-1 sm:grid-cols-2 gap-4" onSubmit={handleSubmit} aria-describedby="contact-help">
            <p id="contact-help" className="sm:col-span-2 text-sm text-[#626266] leading-relaxed">Los campos con * son obligatorios. Al continuar, se abrirá tu aplicación de correo con el mensaje listo para enviar.</p>
            <div className="flex flex-col">
              <label
                htmlFor="nombre"
                className="mb-2 text-xs font-medium text-[#626266]"
              >
                NOMBRE *
              </label>
              <input
                type="text"
                id="nombre"
                name="nombre"
                required
                autoComplete="given-name"
                  className="w-full h-12 px-0 sm:px-4 border-b border-[#D1D6DA]"
              />
            </div>
            <div className="flex flex-col">
              <label
                htmlFor="apellido"
                className="mb-2 text-xs font-medium text-[#626266]"
              >
                APELLIDO
              </label>
              <input
                type="text"
                id="apellido"
                name="apellido"
                autoComplete="family-name"
                  className="w-full h-12 px-0 sm:px-4 border-b border-[#D1D6DA]"
              />
            </div>
            <div className="flex flex-col">
              <label
                htmlFor="email"
                className="mb-2 text-xs font-medium text-[#626266]"
              >
                EMAIL *
              </label>
              <input
                type="email"
                id="email"
                name="email"
                required
                autoComplete="email"
                  className="w-full h-12 px-0 sm:px-4 border-b border-[#D1D6DA]"
              />
            </div>
            <div className="flex flex-col">
              <label
                htmlFor="telefono"
                className="mb-2 text-xs font-medium text-[#626266]"
              >
                TELÉFONO
              </label>
              <input
                type="tel"
                id="telefono"
                name="telefono"
                autoComplete="tel"
                  className="w-full h-12 px-0 sm:px-4 border-b border-[#D1D6DA]"
              />
            </div>
            <div className="flex flex-col">
              <label
                htmlFor="asunto"
                className="mb-2 text-xs font-medium text-[#626266]"
              >
                ASUNTO
              </label>
              <input
                type="text"
                id="asunto"
                name="asunto"
                  className="w-full h-12 px-0 sm:px-4 border-b border-[#D1D6DA]"
              />
            </div>
            <div className="flex flex-col">
              <label
                htmlFor="pais"
                className="mb-2 text-xs font-medium text-[#626266]"
              >
                PAÍS
              </label>
              <input
                type="text"
                id="pais"
                name="pais"
                autoComplete="country-name"
                  className="w-full h-12 px-0 sm:px-4 border-b border-[#D1D6DA]"
              />
            </div>
            <div className="flex flex-col col-span-1 sm:col-span-2">
              <label
                htmlFor="mensaje"
                className="mb-2 text-xs font-medium text-[#626266]"
              >
                MENSAJE *
              </label>
              <textarea
                id="mensaje"
                name="mensaje"
                required
                className="w-full h-24 px-4 border border-[#D1D6DA] rounded-xl"
              />
            </div>
            <button className="col-span-1 sm:col-span-2 w-full h-12 bg-[#3A3A3C] hover:bg-[#565659] transition-colors text-white font-bold rounded-lg text-xs text-medium">
              CONTINUAR EN MI CORREO
            </button>
          </form>
        </div>
      </div>
    </>
  );
}

export default Contacto;
